<template>
  <v-img v-if="show" :src="premiumIcon" class="premium-feature-icon ml-2"></v-img>
</template>

<script>
const premiumIcon = require("@/assets/premium-feature-chip.png")
export default {
  name: "PremiumFeatureIcon",
  data() {
    return {
      premiumIcon: premiumIcon
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>

.premium-feature-icon{
  width: 22px;
  height: 22px;
  top: 4px;
  display: inline-block;
}

</style>
